import * as React from "react";
import {
  container,
  circleBackgroud,
  socialMediaLinks,
} from "./SocialMedia.module.scss";
import { StaticImage } from "gatsby-plugin-image";
import { Container } from "react-bootstrap";

export const StyledContainer: React.FC<any> = (props) => {
  return (
    <Container fluid="sm" className={container}>
      {props.children}
    </Container>
  );
};

export const SocialMediaLinks: React.FC = () => {
  return (
    <ul className={socialMediaLinks}>
      <li>
        <a
          className={circleBackgroud}
          id="youtube-link"
          href="https://www.youtube.com/user/SonestaHotels/"
          rel="nofollow noreferrer"
          target="_blank"
        >
          <StaticImage
            src={"../../../svg/you-tube.svg"}
            alt="youtube"
            placeholder="blurred"
            layout="fixed"
            formats={["png", "webp"]}
          />
        </a>
      </li>
      <li>
        <a
          className={circleBackgroud}
          id="facebook-link"
          href="https://www.facebook.com/SonestaHotels/"
          rel="nofollow noreferrer"
          target="_blank"
        >
          <StaticImage
            src={"../../../svg/facebook.svg"}
            alt="facebook"
            placeholder="blurred"
            layout="fixed"
            formats={["png", "webp"]}
          />
        </a>
      </li>
      <li>
        <a
          className={circleBackgroud}
          id="instagram-link"
          href="https://www.instagram.com/sonestahotels"
          rel="nofollow noreferrer"
          target="_blank"
        >
          <StaticImage
            src={"../../../svg/instagram.svg"}
            alt="instagram"
            placeholder="blurred"
            layout="fixed"
          />
        </a>
      </li>
    </ul>
  );
};
